window.OpusNoShadowRoot = true;
window.OpusApiCompareAtPrice = true;

let RENDER_TIMER = null;
let LAST_RENDER_TOKEN = null;

function parseMoneyToNumber(text) {
  if (!text) return 0;

  const normalized = text
    .replace(/[^\d,.-]/g, "")
    .replace(/\./g, "")
    .replace(",", ".");

  return Math.round(parseFloat(normalized) * 100) || 0;
}

function handleCartEvents(event) {
  const data = event?.detail?.cart || event?.detail;
  if (!data) return;

  // check plan
  if (
    !(
      window.opusWidget?.plan?.plan === "Advanced" ||
      window.opusWidget?.plan?.plan === "Pro" ||
      window.opusWidget?.plan?.plan === "Basic"
    )
  ) {
    return;
  }

  if (RENDER_TIMER) {
    clearTimeout(RENDER_TIMER);
    RENDER_TIMER = null;
  }

  const renderToken = Symbol("opus-render");
  LAST_RENDER_TOKEN = renderToken;

  RENDER_TIMER = setTimeout(() => {
    if (LAST_RENDER_TOKEN !== renderToken) return;

    const subtotalSection = document.querySelector(
      ".opus-subtotal-amount.money"
    );
    if (!subtotalSection) return;

    document
      .querySelectorAll(".opus-save-row--dynamic")
      .forEach((el) => el.remove());

    const priceDisplays = document.querySelectorAll(
      ".opus-price-display"
    );
    if (!priceDisplays.length) return;

    let compareTotal = 0;

    priceDisplays.forEach((display) => {
      const originalEl = display.querySelector(
        ".opus-original-price.money"
      );
      const finalEl = display.querySelector(
        ".opus-final-price.money"
      );

      if (originalEl && originalEl.textContent.trim()) {
        compareTotal += parseMoneyToNumber(originalEl.textContent);
      } else if (finalEl && finalEl.textContent.trim()) {
        compareTotal += parseMoneyToNumber(finalEl.textContent);
      }
    });

    if (!compareTotal) return;

    const currentTotal =
      parseMoneyToNumber(subtotalSection.textContent) ||
      data.total_price ||
      0;

    const saveTotal = compareTotal - currentTotal;
    if (saveTotal <= 0) return;

    const compareAmount = window.OpusConvertMoney(compareTotal);
    const saveAmount = window.OpusConvertMoney(saveTotal);

    if (LAST_RENDER_TOKEN !== renderToken) return;
    const row = document.createElement("div");
    row.className = "opus-save-row opus-save-row--dynamic";

    row.style.display = "flex";
    row.style.justifyContent = "flex-end";
    row.style.alignItems = "center";
    row.style.gap = "6px";
    row.style.fontSize = "13px";

    row.innerHTML = `
      <span style="color:#d82c0d;font-weight:500;white-space:nowrap;">
        (Spare ${saveAmount})
      </span>
      <span style="text-decoration:line-through;opacity:.7;white-space:nowrap;">
        ${compareAmount}
      </span>
    `;

    subtotalSection.insertAdjacentElement("afterbegin", row);
  }, 300);
}

window.addEventListener("OpusCartChange", handleCartEvents);
window.addEventListener("OpusOpenCartState", handleCartEvents);
